<template>
	<div :class="{ frame: $store.getters.isPc }" style="position: relative;">
		<!-- 关闭按钮 -->
		<div v-if="showLogout" class="logout-view row cb link" @click="logout" :style="{ color: logoutColor }">
			<i class="el-icon-switch-button"></i>
			<span>退出</span>
		</div>
		<components :is="$route.params.name" @navToLogin="$emit('navToLogin')"></components>
	</div>
</template>

<script>
import Guide from '@/components/question/Guide.vue';
import List from '@/components/question/List.vue';
import Login from '@/components/question/Login.vue';
import Choice from '@/components/question/Choice.vue';
import Success from '@/components/question/Success.vue';
import Fail from '@/components/question/Fail.vue';
import Tips from '@/components/question/Tips.vue';
export default {
	data() {
		return {};
	},
	components: {
		Guide,
		List,
		Login,
		Choice,
		Success,
		Fail,
		Tips
	},
	computed: {
		// 是否展示退出按钮
		showLogout() {
			return ['list', 'login'].indexOf(this.$route.params.name.toLowerCase()) == -1 && this.$store.getters.getToken;
		},
		// 退出按钮文字的颜色
		logoutColor() {
			let name = this.$route.params.name.toLowerCase();
			if ('guide' === name) return '#fff';
			else return '#333';
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('logout');
			// this.refreshMenu();
			if (this.$store.getters.isPc) {
				this.$message({
					message: '退出成功',
					type: 'success'
				});
			} else {
				this.$toast('退出成功');
			}
			this.$router.replace({
				path: '/exam/login'
			});
		}
	}
};
</script>

<style scoped lang="less">
.frame {
	width: 375px;
	height: 667px;
	margin: 60px auto;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
	overflow-y: auto;
}
.logout-view {
	position: absolute;
	right: 0.267rem;
	top: 0.267rem;
	z-index: 999;
	// font-weight: 400;
	// color: #333;
	font-size: 0.427rem;
	i {
		margin-top: 0.08rem;
	}
	span {
		margin-left: 0.08rem;
	}
}
</style>
